
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import * as htmlToImage from 'html-to-image';
import { QRCodeCanvas } from "qrcode.react";
import '../../assets/css/idPreview.css'
import { jsPDF } from "jspdf";
import close from '../../assets/icons/close.svg';
import demoPhoto from '../../assets/Images/idimg.png';
import scanner from '../../assets/icons/QRCode.svg';
import demoLogo from '../../assets/icons/college-name.svg';
import demoLogo2 from '../../assets/Images/logocompleteforId.png';
import clgLogo from '../../assets/icons/BanarasInstLogo.svg';
import clgname from '../../assets/icons/Nameclglogo.svg';
import icon1 from '../../assets/icons/idcardicon1.svg';
import icon2 from '../../assets/icons/idcardicon2.svg';
import icon3 from '../../assets/icons/idcardicon3.svg';
import icon4 from '../../assets/icons/idcardicon4.svg';
import sign from '../../assets/Images/idcardsignnew.png';
import next from '../../assets/icons/icon.svg';
import { Postdata, Postdataform } from '../../API/GlobalApi';
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";
import Notifier from '../../Utils/notify';
import formacysign from '../../assets/Images/pharmacy_sign.png'
import pharmacyLogo from '../../assets/Images/ID Card BIP LOGO.png'
import bitelogo from '../../assets/Images/BITE_LOGO.png'
import bitetreelogo from '../../assets/Images/BITE_tree_logo.png'
import bite from '../../assets/Images/BITE.png'

// Capture a DOM node to a canvas. Prefer html-to-image: unlike html2canvas it
// renders CSS mask-image (the concave hero curve + the corner-accent scoop),
// so the printed/downloaded card matches the on-screen design exactly. If it
// fails or hangs, fall back to html2canvas so printing never breaks.
const captureCardCanvas = async (element, pixelRatio) => {
  const withTimeout = (p, ms) =>
    Promise.race([
      p,
      new Promise((_, reject) => setTimeout(() => reject(new Error('capture-timeout')), ms)),
    ]);
  try {
    return await withTimeout(
      htmlToImage.toCanvas(element, {
        pixelRatio,
        backgroundColor: '#ffffff',
        cacheBust: true,
      }),
      25000
    );
  } catch (err) {
    console.warn('html-to-image capture failed, falling back to html2canvas:', err);
    return html2canvas(element, {
      scale: pixelRatio,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
    });
  }
};

// The hero panel has a fixed height (see .id-hero). Long names or program
// aliases would overflow it, so step the name (first) and program badge font
// sizes down until everything fits, but never below a readable minimum.
const fitHeroText = (panel) => {
  if (!panel) return;
  const name = panel.querySelector('.id-name');
  const program = panel.querySelector('.id-program');
  if (!name || !program) return;

  name.style.fontSize = '';
  program.style.fontSize = '';
  const pxPerMm = 96 / 25.4;
  const minSize = 3.4 * pxPerMm;
  const step = 0.2 * pxPerMm;
  let nameSize = parseFloat(getComputedStyle(name).fontSize);
  let programSize = parseFloat(getComputedStyle(program).fontSize);

  const overflows = () =>
    panel.scrollHeight > panel.clientHeight + 1 ||
    name.scrollWidth > name.clientWidth + 1 ||
    program.scrollWidth > program.clientWidth + 1;

  while (overflows() && (nameSize > minSize || programSize > minSize)) {
    if (nameSize >= programSize && nameSize > minSize) {
      nameSize -= step;
      name.style.fontSize = `${nameSize}px`;
    } else {
      programSize -= step;
      program.style.fontSize = `${programSize}px`;
    }
  }
};

export const IDPreviewModal = ({ setcardpreview, selectedOrgDetails, capturedPhoto, idcarddata, setidcarddata, setRefreshKey }) => {
  const [isPrinting, setIsPrinting] = useState(false);

  const admissionYear = selectedOrgDetails?.admission_date
    ? new Date(selectedOrgDetails.admission_date).getFullYear()
    : null;



  const organizationName =
    selectedOrgDetails?.lag?.academic_group?.specialization?.course?.organization?.name;

  const isPharmacy = organizationName?.includes("Pharmacy");

  const logoSrc = isPharmacy ? pharmacyLogo : bitetreelogo;

  const programCourse =
    selectedOrgDetails?.lag?.academic_group?.specialization?.course
    || selectedOrgDetails?.provisional_academic_group?.specialization?.course;

  // Badge shows the short program alias (e.g. "M.A.", "B.Ed."); fall back to
  // the full course name, then N/A.
  const programName = programCourse?.alias || programCourse?.name || 'N/A';

  const displayName = isPharmacy
    ? "Banaras Institute of Pharmacy"
    : "Banaras Institute of Teacher's Education";


  const emailDomain = isPharmacy
    ? { website: "bipvns.org", email: "enquiry@bipvns.org", contact1: "7706033222", contact2: "9151807550" }
    : { website: "bitevns.ac.in", email: "enquiry@bitevns.ac.in", contact1: "7704033222", contact2: "9151807551" };




  const passingYear = selectedOrgDetails?.passing_year;
  const sessionText = admissionYear && passingYear
    ? `${admissionYear}–${String(passingYear).slice(-2)}`
    : 'N/A';

  const downloadElementAsJpeg = async (id, fileName) => {
    const element = document.getElementById(id);
    if (!element) return;

    const canvas = await captureCardCanvas(element, 2);
    const dataUrl = canvas.toDataURL('image/jpeg', 1.0);

    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = `${fileName}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadold = () => {
    const finalobj = {
      id_card_student_picture: '',
      id_card_photo_back: '',
    }
    let url = `students/students-attendance/`;
    let res = Postdata(url, finalobj);

    downloadElementAsJpeg("id-card-front", "IDCard_Front");
    setTimeout(() => {
      downloadElementAsJpeg("id-card-back", "IDCard_Back");
    }, 800);
  };
  const handleDownload = async () => {
    const frontCanvas = await captureCardCanvas(document.getElementById("id-card-front"), 2);
    const backCanvas = await captureCardCanvas(document.getElementById("id-card-back"), 2);

    const frontBlob = await new Promise((resolve) => frontCanvas.toBlob(resolve, "image/jpeg"));
    const backBlob = await new Promise((resolve) => backCanvas.toBlob(resolve, "image/jpeg"));

    const uploadFile = async (blob, filename) => {
      const formData = new FormData();
      formData.append("file", blob, filename);
      const response = await Postdataform("staff/upload-file/", formData)

      return response?.file_url;
    };

    try {
      const frontUrl = await uploadFile(frontBlob, "IDCard_Front.jpg");
      const backUrl = await uploadFile(backBlob, "IDCard_Back.jpg");

      const finalobj = {
        student: selectedOrgDetails.user_id,
        id_card_student_picture: frontUrl,
        id_card_photo_back: backUrl,
      };

      const saveResponse = await Postdata("students/students-attendance/", finalobj);
      downloadElementAsJpeg("id-card-front", "IDCard_Front");
      setTimeout(() => {
        downloadElementAsJpeg("id-card-back", "IDCard_Back");
      }, 800);
    } catch (err) {

    }
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isPrinting) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isPrinting]);


  const checkPrinterStatus = async () => {
    const token = "token";

    // const res = await fetch("http://192.168.1.44:8000/print/status", {
    //   method: "GET",
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // });


    const res = await fetch("http://localhost:8000/print/status", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("response in printer status", res)

    if (!res.ok) {
      throw new Error("Printer status check failed");
    }

    return await res.json();
  };



  const handleDownloadAndPrint = async () => {
    try {
      showPrintLoadingAlert("Checking printer status...");
      setIsPrinting(true);
      // -------------------------------------------
      // 1️⃣ CHECK PRINTER STATUS FIRST
      // -------------------------------------------
      const statusRes = await checkPrinterStatus();
      console.log("response in printer status", statusRes)
      if (!statusRes?.connected || !statusRes?.online || !statusRes?.ready) {
        Swal.close();
        showPrinterOfflineAlert();
        return;
      }


      // -------------------------------------------
      // 2️⃣ START PRINT PROCESS
      // -------------------------------------------
      showPrintLoadingAlert("Preparing ID Card...");

      // Convert element to high-res image
      const elementToImage = async (id) => {
        const element = document.getElementById(id);
        // html-to-image renders CSS masks, so the concave curve + corner
        // accent are preserved in the printed output (html2canvas drops them).
        const canvas = await captureCardCanvas(element, 6);
        return {
          dataURL: canvas.toDataURL("image/png", 1.0),
          width: canvas.width,
          height: canvas.height
        };
      };

      // Upload blob function
      const uploadFile = async (blob, filename) => {
        const formData = new FormData();
        formData.append("file", blob, filename);
        const response = await Postdataform("staff/upload-file/", formData);
        return response?.file_url;
      };

      // Convert Base64 → Blob
      const base64ToBlob = async (base64) => {
        const res = await fetch(base64);
        return await res.blob();
      };

      // Get front/back images
      const frontImgObj = await elementToImage("id-card-front");
      const backImgObj = await elementToImage("id-card-back");

      // Convert to blobs
      const frontBlob = await base64ToBlob(frontImgObj.dataURL);
      const backBlob = await base64ToBlob(backImgObj.dataURL);

      // Upload to server
      const frontUrl = await uploadFile(frontBlob, "IDCard_Front.png");
      const backUrl = await uploadFile(backBlob, "IDCard_Back.png");

      // Save backend object
      await Postdata("students/students-attendance/", {
        student: selectedOrgDetails.user_id,
        id_card_student_picture: frontUrl,
        id_card_photo_back: backUrl
      });

      // -------------------------------------------
      // CREATE HIGH-RES PDF
      // -------------------------------------------
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: [frontImgObj.width, frontImgObj.height] // Use canvas dimensions for full sharpness
      });

      pdf.addImage(frontImgObj.dataURL, "PNG", 0, 0, frontImgObj.width, frontImgObj.height);
      pdf.addPage([backImgObj.width, backImgObj.height]);
      pdf.addImage(backImgObj.dataURL, "PNG", 0, 0, backImgObj.width, backImgObj.height);

      // Create Blob URL for printing
      const pdfBlob = pdf.output("blob");
      const pdfURL = URL.createObjectURL(pdfBlob);
      const jobId = uuidv4();

      const printFormData = new FormData();
      printFormData.append("job_id", jobId);
      printFormData.append("pdf_file", pdfBlob, "IDCard.pdf");

      const token = "token"
      // const res = await fetch("http://192.168.1.44:8000/print", {
      //   method: "POST",
      //   headers: {
      //     Authorization: `Bearer ${token}`, // <-- your auth token
      //   },
      //   body: printFormData,
      // });
      const res = await fetch("http://localhost:8000/print", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // <-- your auth token
        },
        body: printFormData,
      });

      if (!res.ok) {
        throw new Error("Printer failed");
      }

      Swal.close();
      showPrintSuccessAlert();

      if (res.ok && res.status === 200 && res.statusText === "OK") {
        console.log("Printer success");
        setIsPrinting(false);
        setRefreshKey(prev => prev + 1)
      } else {
        Swal.close(); // close loading modal
        showPrintSuccessAlert();
        throw new Error("Printer failed");
      }

      // Print
      // const printWin = window.open(pdfURL);
      // printWin.onload = () => {
      //   printWin.focus();
      //   printWin.print();
      // };

      // Optional: download PDF
      // pdf.save("IDCard.pdf");

    } catch (error) {
      console.error("PDF/Print Error:", error);
      Swal.close();
      showPrintErrorAlert();
    } finally {
      setIsPrinting(false);
    }
  };


  const showPrintLoadingAlert = (message = "Printing in progress") => {
    Swal.fire({
      title: message,
      text: "Please do not refresh or close the browser.",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  };

  const showPrinterOfflineAlert = () => {
    Swal.fire({
      icon: "warning",
      title: "Printer not connected",
      text: "Please check the printer connection and try again.",
      confirmButtonText: "OK",
    }).then((result) => {
      if (result.isConfirmed) {
        setcardpreview(false); // ✅ CLOSE MODAL
      }
    });;
  };


  const showPrintSuccessAlert = () => {
    Swal.fire({
      icon: "success",
      title: "Print job done",
      text: "The PDF has been successfully sent to the printer.",
      confirmButtonText: "OK",
    }).then((result) => {
      if (result.isConfirmed) {
        setcardpreview(false); // ✅ CLOSE MODAL
      }
    });;
  };


  const showPrintErrorAlert = () => {
    Swal.fire({
      icon: "error",
      title: "Print failed",
      text: "Unable to send PDF to printer. Please try again.",
      confirmButtonText: "OK",
    }).then((result) => {
      if (result.isConfirmed) {
        setcardpreview(false); // ✅ CLOSE MODAL
      }
    });;
  };

  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [resendTimer, setResendTimer] = useState(0); // seconds

  const otpInputs = useRef([]);


  const formatDateDMY = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date)) return 'N/A';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}-${month}-${date.getFullYear()}`;
  };

  const getPrimaryMobileNumber = () => {
    const primaryContact = selectedOrgDetails?.contact_numbers?.find(
      (c) => c.is_primary && c.contact_type === "Mobile"
    );

    return primaryContact?.number || "";
  };


  const handleOpenOtp = async () => {
    try {
      setIsSendingOtp(true);
      const phone = getPrimaryMobileNumber();
      if (!phone) {
        Notifier.info("Primary mobile number is missing");
        return;
      }
      const res = await Postdata("students/student-admission/send-sms/", {
        student_id: selectedOrgDetails.user_id,
        phone_number: phone,
      });
      if (!res.error) {
        Notifier.success("OTP sent successfully");
        setShowOtp(true);
        setResendTimer(30); // ⏳ 30 sec timer
      }
      // Focus first OTP input
      setTimeout(() => otpInputs.current[0]?.focus(), 100);

    } catch (err) {
      console.error("OTP send failed", err);
      Notifier.error("Failed to send OTP");
    } finally {
      setIsSendingOtp(false);
    }
  };



  useEffect(() => {
    if (resendTimer === 0) return;

    const interval = setInterval(() => {
      setResendTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [resendTimer]);

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      otpInputs.current[index + 1].focus();
    }
  };



  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpInputs.current[index - 1]?.focus();
    }

    if (e.key === "Enter" && index === 5) {
      handleVerifyOtp();
    }
  };

  const handleVerifyOtp = async () => {
    try {
      setIsVerifyingOtp(true);
      const phone = getPrimaryMobileNumber();
      if (!phone) {
        Notifier.info("Primary mobile number is missing");
        return;
      }
      const enteredOtp = otp.join("");
      const res = await Postdata("students/student-admission/verify-sms/", {
        student_id: selectedOrgDetails.user_id,
        phone_number: phone,
        otp: enteredOtp,
      });

      console.log("response in otp verify", res)
      // ❌ OTP INVALID → STOP HERE
      if (res?.error) {
        Notifier.error(res.error || "Invalid OTP");
        return; // 🔥 IMPORTANT
      }
      Notifier.success("OTP verified successfully");
      setShowOtp(false);
      setOtp(["", "", "", "", "", ""]);
      setRefreshKey(prev => prev + 1)
      // ✅ NOW PRINT
      handleDownloadAndPrint();

    } catch (err) {
      Notifier.error("Invalid OTP");
    } finally {
      setIsVerifyingOtp(false);
    }
  };


  const registrationNumber = selectedOrgDetails?.permanent_registration_number || "";

  const heroInfoRef = useRef(null);
  useLayoutEffect(() => {
    fitHeroText(heroInfoRef.current);
  }, [selectedOrgDetails, programName]);

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ position: 'relative', width: '90%', height: "95vh" }}>
        <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 className='text-primary'>ID Card Preview</h2>
          <button className="close-btn" onClick={() => setcardpreview(false)}>
            <img src={close} alt="close" />
          </button>
        </div>

        <div className="modal-body" style={{ display: 'flex', justifyContent: 'center', gap: '20px', padding: '20px' }}>
          {/* ===================== FRONT SIDE ===================== */}
          <div id="id-card-front" className="idcard">
            <div className="corner-accent">
              <span className="ca-bar" />
              <span className="ca-line" />
            </div>

            <div className="card-logo">
              <img src={logoSrc} alt="logo" />
              <span className="logo-rule" />
            </div>

            <div className="id-hero">
              <div className="id-photo">
                <img src={capturedPhoto || demoPhoto} alt="student" />
              </div>
              <div className="id-hero-info" ref={heroInfoRef}>
                <div className="id-role">STUDENT</div>
                <div className="id-name">
                  <b>{selectedOrgDetails?.first_name || ''}</b>{' '}
                  <span>
                    {selectedOrgDetails?.middle_name &&
                      selectedOrgDetails.middle_name.toLowerCase() !== 'null'
                      ? selectedOrgDetails.middle_name + ' '
                      : ''}
                    {selectedOrgDetails?.last_name || ''}
                  </span>
                </div>
                <div className="id-hero-divider" />
                <div className="id-program">{programName}</div>
              </div>
            </div>

            <div className="id-details">
              <div className="id-fields">
                <div className="id-field">
                  <span className="id-ficon">
                    <svg viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg>
                  </span>
                  <div>
                    <div className="id-flabel">Enrollment No.</div>
                    <div className="id-fvalue">{selectedOrgDetails?.permanent_registration_number || 'N/A'}</div>
                  </div>
                </div>
                <div className="id-field">
                  <span className="id-ficon">
                    <svg viewBox="0 0 24 24"><path d="M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8z" /></svg>
                  </span>
                  <div>
                    <div className="id-flabel">Blood Group</div>
                    <div className="id-fvalue">{selectedOrgDetails?.blood_group || 'N/A'}</div>
                  </div>
                </div>
                <div className="id-field">
                  <span className="id-ficon">
                    <svg viewBox="0 0 24 24"><path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM7 11h5v5H7z" /></svg>
                  </span>
                  <div>
                    <div className="id-flabel">Session</div>
                    <div className="id-fvalue">{selectedOrgDetails?.academic_year_name || sessionText}</div>
                  </div>
                </div>
              </div>
              <div className="id-qr">
                <QRCodeCanvas
                  value={registrationNumber}
                  size={140}
                  level="H"
                  fgColor="#16247a"
                  bgColor="#ffffff"
                />
              </div>
            </div>

            <div className="id-footer">
              <div className="id-footer-accent"><span /><span /></div>
              <div className="id-footer-name">{displayName || 'N/A'}</div>
              <div className="id-footer-sub">
                <span className="ln" />
                <i className="dot" />
                <span className="txt">www.{emailDomain.website}</span>
                <i className="dot" />
                <span className="ln" />
              </div>
            </div>
          </div>

          {/* ===================== BACK SIDE ===================== */}
          <div id="id-card-back" className="idcard">
            <div className="card-logo card-logo-back">
              <img src={logoSrc} alt="logo" />
              <span className="logo-rule" />
            </div>

            <div className="id-back-info">
              <div className="id-brow">
                <span className="id-blabel">Contact:</span>
                <span className="id-bvalue">{selectedOrgDetails?.contact_numbers?.[0]?.number || 'N/A'}</span>
              </div>
              <div className="id-brow">
                <span className="id-blabel">DOB:</span>
                <span className="id-bvalue">{formatDateDMY(selectedOrgDetails?.date_of_birth)}</span>
              </div>
              <div className="id-brow">
                <span className="id-blabel">Address:</span>
                <span className="id-bvalue">
                  {selectedOrgDetails?.addresses?.[0]?.address || 'N/A'}, {selectedOrgDetails?.addresses?.[0]?.city?.name || 'N/A'}, {selectedOrgDetails?.addresses?.[0]?.state?.name || 'N/A'} - {selectedOrgDetails?.addresses?.[0]?.pincode || ''}
                </span>
              </div>
            </div>

            <div className="id-terms">
              <div className="id-terms-title">Terms &amp; Conditions</div>
              <ul>
                <li>This Card is Institutional property; to be carried at all times by the student.</li>
                <li>Must be presented on demand. Loss or damage to be reported promptly. Replacement fee may apply.</li>
                <li>Any misuse or tampering is subject to disciplinary action.</li>
              </ul>
            </div>

            <div className="id-back-spacer" />

            <div className="id-back-bottom">
              <div className="id-sign">
                {isPharmacy ? <img src={formacysign} alt="Sign" /> : <img src={sign} alt="Sign" />}
                <div>Principal</div>
              </div>
              <div className="id-call">Call: {emailDomain.contact1} | {emailDomain.contact2}</div>
            </div>

            <div className="id-footer id-footer-back">
              <div className="id-footer-accent"><span /><span /></div>
              <div className="id-footer-name">{displayName || 'N/A'}</div>
              <div className="id-footer-sub">
                <span className="ln" />
                <i className="dot" />
                <span className="txt">Babatpur, Varanasi 221204</span>
                <i className="dot" />
                <span className="ln" />
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
          {/* <button className='add-btn' style={{ width: "12%", display: 'flex', justifyContent: 'center' }} onClick={handleDownload}> */}
          {/* <button className='add-btn' style={{ width: "12%", display: 'flex', justifyContent: 'center' }} onClick={handleDownload}>
            Download <img src={next} className='ms-2' alt="next" />
          </button> */}
          {/* <button className='add-btn' disabled={isPrinting} style={{ width: "12%", display: 'flex', justifyContent: 'center' }} onClick={handleOpenOtp}>
            {isPrinting ? (
              <span className="spinner-border spinner-border-sm" />
            ) : (
              <>
                Print ID Card
              </>
            )}
          </button> */}

          {/* {isPrinting && (
            <div style={{ marginTop: 10, color: "red", fontSize: "13px" }}>
              Printing in progress. Please do not refresh or close the browser.
            </div>
          )}  
        </div>
        <div
          className="col-md-12"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            marginTop: 20,
          }}
        >
          {/* Print Button */}
          <button
            className="add-btn"
            disabled={isSendingOtp}
            onClick={handleOpenOtp}
          >
            {isSendingOtp ? "Sending OTP..." : "Print ID Card"}
          </button>

          {/* INLINE OTP SECTION */}
          {showOtp && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "8px 12px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                background: "#fff",
              }}
            >
              {/* OTP Inputs */}
              {otp.map((d, i) => (
                <input
                  key={i}
                  ref={(el) => (otpInputs.current[i] = el)}
                  value={d}
                  maxLength={1}
                  onChange={(e) => handleOtpChange(e, i)}
                  onKeyDown={(e) => handleOtpKeyDown(e, i)}
                  style={{
                    width: "32px",
                    height: "32px",
                    textAlign: "center",
                    fontSize: "14px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                  }}
                />
              ))}

              {/* Verify Button */}
              <button
                className="add-btn"
                // disabled={isVerifyingOtp || otp.join("").length !== 6}
                style={{ padding: "6px 10px" }}
                onClick={handleVerifyOtp}
              >
                {isVerifyingOtp ? "Verifying..." : "Verify"}
              </button>

              {/* Resend OTP */}
              <div style={{ marginLeft: "6px", fontSize: "12px" }}>
                {resendTimer > 0 ? (
                  <span style={{ color: "#777", textDecoration: 'underline' }}>
                    Resend in {resendTimer}s
                  </span>
                ) : (
                  <span
                    style={{ color: "#7F56DA", cursor: "pointer", fontWeight: 500 }}
                    onClick={handleOpenOtp}
                  >
                    Resend OTP
                  </span>
                )}
              </div>
            </div>
          )}

        </div>



      </div>
    </div>
  );
};


